<template>
  <div class="achievement-comparison-table">
    <el-tabs v-model="examName" @tab-click="handleClick" v-if="studentList.length">
      <el-tab-pane v-for="(item, index) in studentList" :key="index" :label="getLabel(item)" :name="'' + index">
        <el-table :data="item" style="width: 100%">
          <el-table-column prop="className" label="班级" align="center"> </el-table-column>
          <el-table-column prop="studentName" label="姓名" align="center"> </el-table-column>
          <el-table-column prop="studentNumber" label="学号" align="center"> </el-table-column>
          <el-table-column label="班级排名" align="center" width="120">
            <template slot-scope="{ row }">
              <span>{{ getClassRankInfo(row, 0) }}</span>
              <span style="color: #b2b2b3">
                / {{ getClassRankInfo(row, 1) }}
              </span>
              <span>
                / {{ getRankDifference(row) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="年级排名" align="center" width="120">
            <template slot-scope="{ row }">
              {{ getRankInfo(row, 'gradeRank') }} /
              <span style="color: #b2b2b3">
                {{ getRankInfo(row, 'gradeRank', 1) }}
              </span> /
              <span>{{ typeof row.gradeProgressRanking === 'number' && row.gradeProgressRanking != null && row.gradeProgressRanking != undefined ?
                row.gradeProgressRanking : '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="avgScore" label="平均分" align="center" :width="labelWidth">
            <template slot-scope="{ row }">
              {{ getScoreInfo(row, 'avgScore') }} /
              <span style="color: #b2b2b3">
                {{ getScoreInfo(row, 'avgScore', 1) }}
              </span> /
              <span>{{ calculateDifference(row, 'avgScore') }}</span>
            </template>
          </el-table-column>

          <el-table-column label="总分" align="center" :width="labelWidth">
            <template slot-scope="{ row }">
              {{ getScoreInfo(row, 'totalScore') }} /
              <span style="color: #b2b2b3">
                {{ getScoreInfo(row, 'totalScore', 1) }}
              </span> /
              <span>{{ calculateDifference(row, 'totalScore') }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="1">
          </el-table-column>
          <div v-for="(item, index) in courseList" :key="index">
            <!-- 分数列 -->
            <el-table-column :label="item" align="center" :width="labelWidth">
              <template slot-scope="{ row }">
                <span v-if="hasData(row, item, 'score')">{{ getData(row, item, 'score', 0) }}</span><span
                  v-else>-</span> /
                <span style="color: #b2b2b3" v-if="hasData(row, item, 'score', 1)">
                  {{ getData(row, item, 'score', 1) }}
                </span><span v-else>-</span> / <span
                  v-if="hasData(row, item, 'score', 1) && hasData(row, item, 'score')">{{ parseFloat((getData(row,
                    item, 'score', 1) - getData(row, item, 'score', 0)).toFixed(2))
                  }}</span><span v-else>-</span>
              </template>
            </el-table-column>

            <!-- 排名列 -->
            <el-table-column :label="'班级排名进退步'" align="center" width="120">
              <template slot-scope="{ row }">
                <span v-if="hasData(row, item, 'classRank')">{{ getData(row, item, 'classRank', 0) }}</span><span
                  v-else>-</span> /
                <span style="color: #b2b2b3" v-if="hasData(row, item, 'classRank', 1)">
                  {{ getData(row, item, 'classRank', 1) }}
                </span><span v-else>-</span> /
                <span v-if="hasData(row, item, 'classRank', 1) && hasData(row, item, 'classRank')">{{ getData(row, item,
                  'classRank', 0) - getData(row, item, 'classRank', 1) }}</span><span v-else>-</span>
              </template>
            </el-table-column>

            <!-- 排名列 -->
            <el-table-column :label="'年级排名进退步'" align="center" width="120">
              <template slot-scope="{ row }">
                <span v-if="hasData(row, item, 'gradeRank')">{{ getData(row, item, 'gradeRank', 0) }}</span><span
                  v-else>-</span> /
                <span style="color: #b2b2b3" v-if="hasData(row, item, 'gradeRank', 1)">
                  {{ getData(row, item, 'gradeRank', 1) }}
                </span><span v-else>-</span> /
                <span v-if="hasData(row, item, 'gradeRank', 1) && hasData(row, item, 'gradeRank')">{{ getData(row, item,
                  'gradeRank', 0) - getData(row, item, 'gradeRank', 1) }}</span><span v-else>-</span>
              </template>
            </el-table-column>
          </div>
          <!-- <el-table-column prop="gradeProgressRanking" label="年级进步名次">
          </el-table-column> -->
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  props: ["studentList", "courseList"],
  data() {
    return {
      examName: "",
      labelWidth: 200
    };
  },
  mounted() {
    // console.log("studentList:", this.studentList);
    this.examName = "0";
  },
  methods: {
    // 获取指定索引处的classRank信息，如果不存在则返回'-'
    getClassRankInfo(row, index) {
      if (row.examInfoScoreList && row.examInfoScoreList[index] && 'classRank' in row.examInfoScoreList[index]) {
        return row.examInfoScoreList[index].classRank;
      }
      return '-';
    },

    // 计算两个classRank之间的差异，如果任何一个不存在，则返回'-'
    getRankDifference(row) {
      const rank1 = this.getClassRankInfo(row, 0);
      const rank2 = this.getClassRankInfo(row, 1);

      if (rank1 !== '-' && rank2 !== '-') {
        return rank1 - rank2;
      }
      return '-';
    },
    // 获取指定属性的信息，如果不存在则返回'-'
    getInfo(row, prop, index = 0) {
      if (row.examInfoScoreList && row.examInfoScoreList[index] && prop in row.examInfoScoreList[index]) {
        return row.examInfoScoreList[index][prop];
      }
      return '-';
    },

    // 获取排名信息
    getRankInfo(row, rankProp, index = 0) {
      return this.getInfo(row, rankProp, index);
    },

    // 获取分数信息（平均分或总分）
    getScoreInfo(row, scoreProp, index = 0) {
      const score = this.getInfo(row, scoreProp, index);
      return score !== '-' ? parseFloat(score).toFixed(2) : '-';
    },

    // 计算两个值之间的差异，如果任何一个不存在，则返回'-'
    calculateDifference(row, prop) {
      const value1 = this.getScoreInfo(row, prop, 0);
      const value2 = this.getScoreInfo(row, prop, 1);

      if (value1 !== '-' && value2 !== '-') {
        return parseFloat((value2 - value1).toFixed(2));
      }
      return '-';
    },
    getLabel(item) {
      // 查找 examInfoScoreList.length > 1 的第一个 item
      const validItem = item.find(i => i.examInfoScoreList && i.examInfoScoreList.length > 1);

      if (validItem) {
        // 如果找到了符合条件的 item，则使用它的 title 和 subTitle 构建标签
        return `${validItem.examInfoScoreList[0].title}${validItem.examInfoScoreList[0].subTitle} - ${validItem.examInfoScoreList[1].title}${validItem.examInfoScoreList[1].subTitle}`;
      } else {
        // 如果没有找到符合条件的 item，则提供默认行为或错误处理
        // 这里可以返回一个默认值或者选择其他的展示逻辑
        return '考试对比'; // 根据需要调整这里的内容
      }
    },
    handleClick(e) {
      // console.log("handleClick:", this.examName);
    },
    hasData(row, courseName, dataType, examIndex = 0) {
      const examInfo = row.examInfoScoreList[examIndex];
      return examInfo && examInfo.courseScoreList.some(aItem => aItem.courseName === courseName);
    },
    getData(row, courseName, dataType, examIndex = 0) {
      const courseScore = row.examInfoScoreList[examIndex]?.courseScoreList.find(
        aItem => aItem.courseName === courseName
      );
      return courseScore ? courseScore[dataType] : '-';
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementComparisonTable.scss";
</style>